/*globals jQuery, tabSet, responsiveTables */
import { debounce } from '../_debounce';
( function( $, undefined ) {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	window.MSR.document = ( function( $ ) {
		/******* DOCUMENT EVENTS *******/

		var MSR_i18n = window.MSR_i18n;

		var init = function() {
			window.MSR.responsive.checkSupportedScripts();

			window.MSR.sameHeightElements.init();

			window.MSR.expandCollapse.init();

			window.MSR.galleryModal.init();

			var msrTabs = tabSet( '.c-tabs' );

			var eventsTable = responsiveTables( '.msr-table-schedule' );

			blogPagination();
		};

		/**
		 * Add aria label to pagination,
		 * Update aria current value
		 */
		var blogPagination = function() {
			if ( ! document.body.classList.contains( 'page-template-template-blog' ) ) {
				return;
			}

			var currentPage = document.querySelector( '[aria-current="page"]' );

			if ( ! currentPage ) {
				return;
			}

			currentPage.setAttribute( 'aria-current', 'true' );
			currentPage.setAttribute( 'aria-label', MSR_i18n.currentPageText + ', ' + MSR_i18n.pageText + ' ' + currentPage.innerText );

			listBlogPagination();
		};

		/**
		 * Turn blog pagination into a list
		 */
		var listBlogPagination = function() {
			if ( ! document.body.classList.contains( 'page-template-template-blog' ) ) {
				return;
			}

			var pagination = document.querySelector( '.pagination' );

			if ( ! pagination ) {
				return;
			}

			var ul = $( '<ul />' ),
				children = $( pagination ).children();

			if ( children.length > 0 ) {
				$.each( children, function( index, child ) {
					var li = $( '<li />' );

					li.append( child );

					ul.append( li );
				} );

				$( pagination ).empty().append( ul );
			}
		};

		return {
			init: init
		};
	} )( jQuery );

	$( function() {
		window.MSR.document.init();

		/******* WINDOW EVENTS *******/

		function onResizeScripts() {

			window.MSR.responsive.checkSupportedScripts();

			window.MSR.sameHeightElements.set();
		}

		$( window ).resize( debounce( onResizeScripts, 400 ) );
	} );
} )( jQuery );
